//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IGatewayFacebookPage } from '@apis/facebook-settings/gatewayFacebookSettingsApiModel';
import FacebookPageId from '@models/FacebookPageId';
import { Normalized } from '@utils/normalize';

export enum FACEBOOK_SETTINGS_MODAL_ACTIONS {
  OPEN_MODAL = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/OPEN_MODAL',
  CLOSE_MODAL = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/CLOSE_MODAL',

  REQUEST_AVAILABLE_PAGES = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/REQUEST_AVAILABLE_PAGES',
  RECEIVE_AVAILABLE_PAGES_SUCCEEDED = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/RECEIVE_AVAILABLE_PAGES_SUCCEEDED',
  RECEIVE_AVAILABLE_PAGES_FAILED = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/RECEIVE_AVAILABLE_PAGES_FAILED',

  SET_SELECTED_PAGE = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/SET_SELECTED_PAGE',

  REQUEST_SAVE_SELECTED_PAGE = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/REQUEST_SAVE_SELECTED_PAGE',
  RECEIVE_SAVE_SELECTED_PAGE_SUCCEEDED = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_PAGE_SUCCEEDED',
  RECEIVE_SAVE_SELECTED_PAGE_FAILED = 'FACEBOOK_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_PAGE_FAILED',
}

export interface IFacebookSettingsModalState {
  flags: {
    isFetchingAvailablePages: boolean;
    isOpen: boolean;
    isSavingSelectedPage: boolean;
  };
  availablePages: Normalized<IGatewayFacebookPage, string>;
  saveSelectedPageError?: string;
  selectedPageId?: FacebookPageId;
}
